import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";
import CategoryTabs from "@/components/feature/CategoryTabs";

export default function LatestSection() {
  const latestArticles = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const hotArticles = [...articles]
    .sort((a, b) => b.views - a.views)
    .slice(0, 5);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-5 md:mb-6">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900">
                最新内容
              </h2>
              <a
                href="/category/daily-contest"
                className="text-sm text-rose-500 hover:text-rose-600 font-medium whitespace-nowrap cursor-pointer"
              >
                查看更多 <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
            <CategoryTabs />
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {latestArticles.slice(0, 6).map((article) => (
                <ArticleCard key={article.slug} {...article} />
              ))}
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 mb-5 md:mb-6">
                热门推荐
              </h2>
              <div className="bg-background-50 rounded-lg border border-background-200/60 p-4">
                {hotArticles.map((article, idx) => (
                  <a
                    key={article.slug}
                    href={`/article/${article.slug}`}
                    className={`flex items-start gap-3 py-3 cursor-pointer group ${
                      idx < hotArticles.length - 1
                        ? "border-b border-background-200/60"
                        : ""
                    }`}
                  >
                    <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      idx === 0
                        ? "bg-rose-500 text-white"
                        : idx === 1
                        ? "bg-orange-500 text-white"
                        : idx === 2
                        ? "bg-amber-500 text-white"
                        : "bg-background-200 text-foreground-600"
                    }`}>
                      {idx + 1}
                    </span>
                    <div className="min-w-0">
                      <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-rose-500 transition-colors">
                        {article.title}
                      </h4>
                      <span className="text-xs text-foreground-500 mt-1 block">
                        {article.views > 10000
                          ? `${(article.views / 10000).toFixed(1)}万 阅读`
                          : `${article.views} 阅读`}
                      </span>
                    </div>
                  </a>
                ))}
              </div>

              <div className="mt-5 bg-gradient-to-br from-rose-500 to-orange-500 rounded-lg p-5 text-white">
                <h4 className="font-semibold mb-2">订阅更新</h4>
                <p className="text-sm text-white/80 mb-3">
                  第一时间获取最新吃瓜内容，不错过任何精彩
                </p>
                <form
                  className="flex gap-2"
                  data-readdy-form
                  onSubmit={(e) => e.preventDefault()}
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="输入邮箱地址"
                    className="flex-1 px-3 py-2 rounded-lg text-sm text-foreground-900 bg-white/90 placeholder:text-gray-400 focus:outline-none"
                    required
                  />
                  <button
                    type="submit"
                    className="px-4 py-2 bg-white text-rose-500 font-medium rounded-lg text-sm hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}